export const isArrayWithItems = (arr) => {
    if (!arr) {
        return false;
    }

    return Array.isArray(arr) && arr.length ? true : false;
}